let travelsDetails = [
   {
       id:0,
       name:"COX'S BAZAR",
       details:"Cox's Bazar is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it ...",
       button:"Booking →",
    },
   {
       id:1, 
       name:"SREEMANGAL", 
       details:"Sreemangal, The Tea Capital of Bangladesh A large portion of world's highest quality tea is grown here. It is also called the city of 'two leaves and a bud.",
       button:"Booking →",
    },
   {
       id:2, 
       name:'SUNDARBANS', 
       details:'The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal.',
       button:"Booking →",
    }
];

export default travelsDetails;



